import React, { useEffect, useRef, useState } from "react";
// import { toast } from "react-hot-toast";
// import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import EditSharpIcon from '@mui/icons-material/EditSharp';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce } from "lodash";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Form, Input, } from "reactstrap";
import { customStyles, wljSelectPortalProps } from "../../selectStyles";
import Flatpickr from 'react-flatpickr'
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";




const ProfileEducation = ({
  showUSEREducation,
  handleCloseUSEREducation,
  userUId,
  getUserCcv,
  getUserProfile,
  userData
}) => {
  //********Location DDL Start  ********//
  const { t } = useTranslation();
  useEscapeKeyDown(showUSEREducation, handleCloseUSEREducation);
  const UserCcv = localStorage.getItem("UserCcv");
  const [value, setValue] = useState(null);
  const [page, setPage] = useState(0);
  const [typed, setTyped] = useState("");
  const [options, setOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [display, setDisplay] = useState(false);

  const [error, setError] = useState("");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [checkCurrent, setCheckCurrent] = useState('')
  const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);
  const [showInputInsteadOfDropdownD, setShowInputInsteadOfDropdownD] = useState(false);
  const [showInputInsteadOfDropdownG, setShowInputInsteadOfDropdownG] = useState(false);
  const [showInputInsteadOfDropdownA, setShowInputInsteadOfDropdownA] = useState(false);
  const language = localStorage.getItem("Lang");
  console.log('checkCurrent', checkCurrent);

  const CheckCurrentEducationStatus = async (Id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`UserData/CheckCurrentEducationStatus`, responseData)
        .then((res) => {
          setCheckCurrent(res?.data?.responseData)
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    if (showUSEREducation) {
      CheckCurrentEducationStatus()
    }
  }, [showUSEREducation])

  // console.log('value', value);
  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);
  // console.log('typed', typed);
  const addOptions = () => {
    axios
      .get(
        `Master/GetLocalitiesDDL?search=${typed}&pageNumber=${page + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        console.log("edu", response);
        const data = response.data.responseData.localityList.map((item) => ({
          value: item.locationId,
          label: item.locationName,
        }));
        setPage((prevPage) => prevPage + 1);
        setOptions((prevOptions) => [...prevOptions, ...data]);
        setTotalPages(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpen = () => {
    setPage(1);
  };

  const handleChange = (val) => {
    setValue(val.value);
    setPage(0);
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPage(0);
  };

  const handleMenuScrollToBottom = () => {
    if (page < totalPages) {
      addOptions();
    }
  };

  const renderOption = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typed) {
      addOptions();
    }
  }, [typed]);

  //********Location DDL End  ********//

  //********Institution DDL Start  ********//
  const [valueIns, setValueIns] = useState(null);
  const [pageIns, setPageIns] = useState(0);
  const [typedIns, setTypedIns] = useState("");
  const [optionsIns, setOptionsIns] = useState([]);
  const [totalPagesIns, setTotalPagesIns] = useState(0);
  // console.log('value', value);
  const logValueIns = debounce((typedIns) => {
    setTypedIns(typedIns);
  }, 250);
  const addOptionsIns = () => {
    axios
      .get(
        `Master/GetAllInstitutionsDDL?search=${typedIns}&pageNumber=${pageIns + 1
        }&pageSize=100&DeviceType=Web&LangKey=${language}`
      )
      .then((response) => {
        console.log(response.data.responseData.orgList);
        const newOptions = response.data.responseData.list.map((item) => ({
          value: item.uiDno,
          label: item.name,
          isOrgVrfd: item.isVerified,
          isOrgRgd: item.isRgstrd,
        }));

        // Filter out duplicates based on the institution name (label) or id (value)
        // setOptionsIns((prevOptions) => {
        //   const mergedOptions = [...prevOptions, ...newOptions];
        //   const uniqueOptions = mergedOptions.filter(
        //     (option, index, self) =>
        //       index === self.findIndex((o) => o.value === option.value)
        //   );
        //   return uniqueOptions;
        // });
        setOptionsIns((prevOptions) => {
          const mergedOptions = [...prevOptions, ...newOptions];
          const uniqueOptions = mergedOptions.filter(
            (option, index, self) =>
              index === self.findIndex((o) => o.value === option.value)
          );
          return uniqueOptions;
        });




        setPageIns((prevPage) => prevPage + 1);
        setTotalPagesIns(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenIns = () => {
    setPageIns(1);
  };

  const handleChangeIns = (valueIns) => {
    if (valueIns === null) {
      setValueIns(null);
    } else {
      setValueIns(valueIns.value);
    }
    setPageIns(0);
  };

  const handleInputChangeIns = (typedIns) => {
    logValueIns(typedIns);
    if (!typedIns) setPageIns(0);
  };

  const handleMenuScrollToBottomIns = () => {
    if (pageIns < totalPagesIns) {
      addOptionsIns();
    }
  };

  const renderOptionIns = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typedIns) {
      addOptionsIns();
    }
  }, [typedIns]);

  //********Institution DDL End  ********//

  //********Specialization DDL Start  ********//
  const [specData, setSpecData] = useState([]);
  const [specId, setSpecId] = useState(null);
  const getSpecialization = () => {
    axios
      .get(`Master/GetSpecializationsDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.spclznId,
          label: item.name,
        }));
        setSpecData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getSpecialization();
  }, []);
  //********Specialization DDL End  ********//

  //********Qualification DDL Start  ********//
  const [qualiData, setQualiData] = useState([]);
  const [qualiId, setQualiId] = useState(null);
  const getQualification = () => {
    axios
      .get(`Master/GetQualificationsDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.qlfctnId,
          label: item.name,
        }));
        setQualiData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getQualification();
  }, []);
  //********Qualification DDL End  ********//

  const sessionId = localStorage.getItem("sessionId");
  const [startDate, setStartDateEdu] = useState(null);
  const [field, setField] = useState("");
  const [grade, setGrade] = useState("");
  const [degree, setDegree] = useState("");
  const [activities, setActivities] = useState([]);
  const [present, setPresent] = useState(false);
  const [endDate, setEndDate] = useState("");
  const isEducationDateRangeInvalid =
    Boolean(startDate) &&
    Boolean(endDate) &&
    moment(endDate).isBefore(moment(startDate), "day");

  //********City DDL Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);

  //********City DDL End  ********//

  const reset = () => {
    // setEditingInstitute(null);
    setDisplay(false)
    setCityId([]);
    setStartDateEdu(null);
    setEndDate(null);
    setPresent(false);
    setValue(null);
    setValueIns(null);
    setDescription("");
    setQualiId("");
    setSpecId("");
    setField("");
    setDegree("");
    setGrade("");
    setActivities("");
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setFileName("");
  };

  useEffect(() => {
    if (
      startDate &&
      endDate &&
      moment(endDate).isBefore(moment(startDate), "day")
    ) {
      setEndDate(null);
    }
  }, [startDate, endDate]);

  // const [DropdownValidation, setDropdownValidation] = useState(null);

  // const [errors, setErrors] = useState({});
  const [getOrgInsTId, setGenOrgInstId] = useState('');
  const [sync, setSync] = useState(false);
  console.log('education data', startDate, endDate, getOrgInsTId);
  //********Add Education Start  ********//

  const mappedActivities = Array.isArray(activities)
    ? activities
      .filter((item) => item && item.value) // filter out any null/undefined
      .map((item) => item.value)
      .join(' , ')
    : '';

  // console.log("Activities===>",activities)
  const AddEducation = async (event) => {

    setDisplay(true);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      cityId: cityId,
      startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
      endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
      isPresent: present,
      locationId: null,
      startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
      endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
      description: description,
      institutionUid: valueIns === null ? JSON.stringify(getOrgInsTId) : valueIns,
      field: field,
      degree: degree,
      grade: grade,
      // activities: activities?.map((item) => item.label).join(',') || '',
      activities: mappedActivities,
      langKey: language === "en" ? "" : language,
    };
    // console.log("educationdata00000", data);
    if (cityId === null || field === '' || degree === '' || !startDate || (present === false && !endDate)) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else if (!present && isEducationDateRangeInvalid) {
      setErrorToastMessage("End date cannot be earlier than start date.");
      setShowErrorToast(true);
    } else {
      try {
        await axios.post(`UserData/AddEducationInfo?IsSynced=${sync}`, data).then((resData) => {
          // console.log("resData", resData);
          // toast.success(resData.data.message);

          setToastMessage(resData.data.message);
          setShowToast(true);

          setTimeout(() => {
            handleCloseUSEREducation();
          }, 500);
          getUserProfile();
          reset();
        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }

    }
  };

  //********Add Education End  ********//

  //********Create Education Start  ********//
  const [CreateCCVEducation, setCreateCCVEducation] = useState(false);
  const handleOpenCreateEducation = () => setCreateCCVEducation(true);
  const handleCloseCreateEducation = () => setCreateCCVEducation(false);

  const [institutionName, setInstitutionName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [description, setDescription] = useState("");
  const [publicUrl, setPublicUrl] = useState("");
  const [website, setWebsite] = useState("");
  const [tagline, setTagline] = useState("");
  const [about, setAbout] = useState("");

  const CreateEducation = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      insttnName: institutionName,
      cityId: cityId,
      startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
      endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
      startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
      endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
      isPresent: present,
      locationId: null,
      email: email,
      contactNo: phoneNo,
      publicUrl: publicUrl,
      website: website,
      tagline: tagline,
      about: about,
      description: description,
      // qualificationId: qualiId,
      // specilizationId: specId,
      field: field,
      degree: degree,
      grade: grade,
      activities: mappedActivities,

      startedDate: "",
      logoImage: "",
      backgroudImage: "",
      facebook: "",
      twitter: "",
      instagram: "",
      langKey: language === "en" ? "" : language,
    };
    if (institutionName === '' || cityId === null || field === '' || degree === '' || !startDate || !endDate) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else if (isEducationDateRangeInvalid) {
      setErrorToastMessage("End date cannot be earlier than start date.");
      setShowErrorToast(true);
    } else {
      try {
        await axios
          .post(`UserData/CreateAndAddEducationInfo`, data)
          .then((resData) => {
            console.log("resData", resData.data.responseData);
            //   toast.success(resData.data.message);
            setToastMessage(resData.data.message);
            setShowToast(true);
            getUserProfile();
            handleCloseCreateEducation();
            handleCloseUSEREducation();
            reset()
          });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };

  //********Create Education End  ********//

  const handleInputChanges = (e) => {
    setDegree(e.target.value);
    if (e.target.value.trim() === "") {
      setError("Degree is required");
    } else {
      setError("");
    }
  };

  const [values, setValueInput] = useState({
    institute: "",
  });
  //   const [ valueInput , setValueInput ] = useState()
  function handleChangeInput(e) {
    const newObj = { ...values, [e.target.name]: e.target.value };
    setValueInput(newObj);
  }


  console.log('present', present);

  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };
  const [showTooltip, setShowTooltip] = useState(false);
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");
  console.log('InsName', InsName);

  const targetRef = useRef(null);
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };


  const [newOrgType, setnewOrgType] = useState(null);
  const [orgCity, setOrgCity] = useState(null);
  // const handleSaveInstitution = async () => {
  //   // setDisplay(true); 
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     gnrlOrgName: OrganizationName,
  //     type: 2,
  //     cityId: cityId,
  //     logoImage: fileName,
  //     locationId: null,
  //     langKey: language === "en" ? "" : language,
  //   }

  //   try {
  //     const res = await axios.post("/General/AddGeneralOrgByUser", data);
  //     console.log("resposne new", res);
  //     setGenOrgInstId(res.data.responseData.id);
  //     setnewOrgType(res.data.responseData.value);
  //     // toast.success(res.data.message);
  //     setShowTooltip(false);
  //     setOrganizationName("");
  //     setOrgCity(null);
  //     setFileName("");
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       // toast.warning(error.response.data.message);
  //     } else {
  //       // toast.error(error.response?.data?.message || "An error occurred");
  //     }
  //   }
  // };
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingInstitute, setEditingInstitute] = useState(null);

  const handleCreateNew = () => {
    setIsEditMode(false);
    setEditingInstitute(null);

    setOrganizationName("");
    setCityId("");
    setFileName("");

    setShowTooltip(true);
  };

  const handleEditInstitute = (institute) => {
    console.log("ggdggdgdg", institute);

    setIsEditMode(true);
    setEditingInstitute(institute);

    setOrganizationName(institute.name);
    setCityId(institute.cityId);
    setFileName(institute.logoImage || "");

    setShowTooltip(true);
  };

  const handleSaveInstitution = async () => {
    const data = {
      deviceType: "Web",
      sessionId,
      gnrlOrgName: OrganizationName,
      type: 2,
      cityId,
      logoImage: fileName,
      locationId: null,
      langKey: language === "en" ? "" : language,

      ...(isEditMode && { id: editingInstitute?.id }) // 👈 key line
    };

    try {
      const res = await axios.post("/General/AddGeneralOrgByUser", data);

      setGenOrgInstId(res.data.responseData.id);
      setInsName(res.data.responseData.value);

      setShowTooltip(false);
      setOrganizationName("");
      setFileName("");
      setIsEditMode(false);
      setEditingInstitute(null);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseNewOrg = (e) => {
    e?.preventDefault?.();
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setValueIns(null);
    setFileName("");
    setIsEditMode(false);
    setEditingInstitute(null);
  };


  function checkResumeEducation(resumeEducation) {
    const presentCount = resumeEducation?.filter(
      (exp) => exp.isPresent === true
    ).length;
    console.log("resumeEducation", presentCount);
    if (presentCount >= 2) {
      return (
        <p className="warningText mt-1 me-3 ms-3 ">
          <WarningAmberSharpIcon style={{ fontSize: '16px' }} />{t("modals.Warning")}: {t("User Profile.More than two education are marked as present")}.
        </p>
      );
    }
  }
  //************************education feild Start  ************************// 
  const [isLoading, setIsLoading] = useState(false);
  const [pageF, setPageF] = useState(0);
  const [typedprofile, setTypedprofile] = useState("");
  const [optionsF, setOptionsF] = useState([]);
  const [totalPagesField, settotalPagesField] = useState(0);


  const logValue1 = debounce((typedprofile) => {
    setTypedprofile(typedprofile);
  }, 250);

  const addOptionsField = () => {
    setIsLoading(true);
    const data = {
      pageNumber: pageF + 1,
      pageSize: 10,
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
    }
    axios
      .post(
        `Master/GetEducationInfoDDL?InfoType=Field&search=${typedprofile}`, data
      )
      .then((response) => {
        console.log("response333333333", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsF((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageF((prevPage) => prevPage + 1);
        setIsLoading(false);
        settotalPagesField(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenField = () => {
    setPageF(1);
  };

  const handleChangeField = (value) => {
    if (value === null) {
      setField(null);
    } else {
      setField(value.label);
    }
  };

  const handleInputChangeField = (typedprofile) => {
    logValue1(typedprofile);
    if (!typedprofile) setPageF(0);
  };

  const handleMenuScrollToBottomField = () => {
    if (pageF < totalPagesField) {
      addOptionsField();
    }
  };

  useEffect(() => {
    if (typedprofile) {
      addOptionsField();
    }
  }, [typedprofile]);

  //************************ education feild End  ************************//

  //************************education degree Start  ************************//  
  const [pageD, setPageD] = useState(0);
  const [typedDegree, setTypeddegree] = useState("");
  const [optionsD, setOptionsD] = useState([]);
  const [totalPagesDegree, settotalPagesDegree] = useState(0);


  const logValueD = debounce((typedDegree) => {
    setTypeddegree(typedDegree);
  }, 250);

  const addOptionsDegree = () => {
    setIsLoading(true);
    const data = {
      pageNumber: pageD + 1,
      pageSize: 100,
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
    }
    axios
      .post(
        `Master/GetEducationInfoDDL?InfoType=Degree&search=${typedDegree}`, data
      )
      .then((response) => {
        console.log("responsedddddddddddddddd", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsD((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageD((prevPage) => prevPage + 1);
        setIsLoading(false);
        settotalPagesDegree(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenDegree = () => {
    setPageD(1);
  };

  const handleChangeDegree = (value) => {
    if (value === null) {
      setDegree(null);
    } else {
      setDegree(value.label);
    }
  };

  const handleInputChangeDegree = (typedDegree) => {
    logValueD(typedDegree);
    if (!typedDegree) setPageD(0);
  };

  const handleMenuScrollToBottomDegree = () => {
    if (pageD < totalPagesDegree) {
      addOptionsDegree();
    }
  };

  useEffect(() => {
    if (typedDegree) {
      addOptionsDegree();
    }
  }, [typedDegree]);

  //************************ education degree End  ************************//
  //************************education degree Start  ************************// 
  const [pageG, setPageG] = useState(0);
  const [typedGrade, setTypedGrade] = useState("");
  const [optionsG, setOptionsG] = useState([]);
  const [totalPagesGrade, setTotalPagesGrade] = useState(0);


  const logValueG = debounce((typedGrade) => {
    setTypedGrade(typedGrade);
  }, 250);

  const addOptionsGrade = () => {
    setIsLoading(true);
    const data = {
      pageNumber: pageG + 1,
      pageSize: 100,
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
    }
    axios
      .post(
        `Master/GetEducationInfoDDL?InfoType=Grade&search=${typedGrade}`, data
      )
      .then((response) => {
        console.log("responsedddddddddddddddd", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsG((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageG((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesGrade(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenGrade = () => {
    setPageG(1);
  };

  const handleChangeGrade = (value) => {
    if (value === null) {
      setGrade(null);
    } else {
      setGrade(value.label);
    }
  };

  const handleInputChangeGrade = (typedGrade) => {
    logValueG(typedGrade);
    if (!typedGrade) setPageG(0);
  };

  const handleMenuScrollToBottomGrade = () => {
    if (pageG < totalPagesGrade) {
      addOptionsGrade();
    }
  };

  useEffect(() => {
    if (typedGrade) {
      addOptionsGrade();
    }
  }, [typedGrade]);

  //************************ education degree End  ************************//

  //************************education activity Start  ************************// 

  const [pageA, setPageA] = useState(0);
  const [typedActivities, setTypedActivities] = useState("");
  const [optionsA, setOptionsA] = useState([]);
  const [totalPagesActivities, setTotalPagesActivities] = useState(0);


  const logValueA = debounce((typedActivities) => {
    setTypedActivities(typedActivities);
  }, 250);

  const addOptionsActivity = () => {
    setIsLoading(true);
    const data = {
      pageNumber: pageA + 1,
      pageSize: 100,
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
    }
    axios
      .post(
        `Master/GetEducationInfoDDL?InfoType=Activities&search=${typedActivities}`, data
      )
      .then((response) => {
        console.log("responsedddddddddddddddd", response);
        const data = response?.data?.responseData?.allData;
        // Check if data is an array
        if (Array.isArray(data)) {
          const mappedData = data.map((item, index) => ({
            label: item,
            value: item,
          }));
          console.log("mappedData==>", mappedData)
          setOptionsA((prevOptions) => [...prevOptions, ...mappedData]);
        } else {
          console.error("Expected data to be an array, but got:", data);
        }

        setPageA((prevPage) => prevPage + 1);
        setIsLoading(false);
        setTotalPagesActivities(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };
  const handleOpenActivity = () => {
    setPageA(0);
    setOptionsA([]);
    setIsLoading(true);
    const data = {
      pageNumber: 1,
      pageSize: 100,
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
    };
    axios
      .post(
        `Master/GetEducationInfoDDL?InfoType=Activities&search=${typedActivities || ""}`,
        data
      )
      .then((response) => {
        const responseData = response?.data?.responseData?.allData;
        if (Array.isArray(responseData)) {
          const mappedData = responseData.map((item) => ({
            label: item,
            value: item,
          }));
          setOptionsA(mappedData);
        }
        setPageA(1);
        setIsLoading(false);
        setTotalPagesActivities(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setIsLoading(false);
      });
  };

  const handleChangeActivity = (value) => {
    // if (value === null) { 
    //   setActivities(null);
    // } else {
    setActivities(value || []);
    // } 
  };

  const handleInputChangeActivity = (typedActivities) => {
    logValueA(typedActivities);
    if (!typedActivities) setPageA(0);
  };

  const handleMenuScrollToBottomActivity = () => {
    if (pageA < totalPagesActivities) {
      addOptionsActivity();
    }
  };

  useEffect(() => {
    if (typedActivities) {
      addOptionsActivity();
    }
  }, [typedActivities]);

  //************************ education activity End  ************************//

  useEffect(() => {
    let scrollY = 0;

    if (showUSEREducation) {
      // Save current scroll position
      scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY; // store in dataset

      // Lock scrolling
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    } else {
      // Unlock scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');

      // Restore scroll position
      const storedY = document.body.dataset.scrollY || "0";
      window.scrollTo(0, parseInt(storedY, 10));
    }
  }, [showUSEREducation]);

  const modalContentRef = useRef(null);

  return (
    <>
      {showUSEREducation && (
        <Portal layer="modal">
          <div
            className="modal fade show modal-lg wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" ref={modalContentRef}>
                <div className="setting-header d-flex justify-content-between align-items-center">
                  {/* <h6>Add Education</h6> */}
                  <div className="d-flex align-items-center settings">
                    <h6 className="mb-0 me-3" >{t("User Profile.Add Education")}</h6>
                  </div>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-3 pointer"
                    onClick={handleCloseUSEREducation}
                  />
                </div>
                <Form style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
                  {checkResumeEducation(userData?.viewEducationInfo)}

                  <div className="row modal-p settings CreateCompany" style={{ overflowY: 'auto', flex: 1 }}>
                    <div className="col-md-6 mt-2">
                      <div className="wlj-edu-label-row d-flex align-items-center">
                        <label htmlFor="about" for="institute" className="mb-0">
                          {t("User Profile.Institution")}<span className="text-danger ms-2">*</span>
                        </label>
                        {InsName !== "" ? (
                          <a
                            href="#"
                            onClick={handleCloseNewOrg}
                            className="createModal f-14 ms-2"
                          >
                            {t("User Profile.Close")}
                          </a>
                        ) : (
                          <a
                            href="#"
                            ref={targetRef}
                            onClick={(e) => {
                              e.preventDefault();
                              handleCreateNew();
                            }}
                            className="createModal f-14 ms-2"
                          >
                            {t("User Profile.Create New")}
                          </a>
                        )}
                      </div>
                      <Overlay
                        target={targetRef.current}
                        show={showTooltip}
                        placement="bottom"
                        rootClose
                        container={document.querySelector(".modal")}
                        onHide={() => setShowTooltip(false)} // Close when clicking outside
                      >
                        <Popover id="popover-basic">
                          <Popover.Header as="h3" className="Dark-Body-Card-group">
                            {/* {t("User Profile.Create Institute")} */}
                            {isEditMode
                              ? t("User Profile.Edit Institute")
                              : t("User Profile.Create Institute")}
                          </Popover.Header>
                          <Popover.Body className="Dark-Body-Card-group">
                            <Form>
                              <div>
                                <label className="mb-1 Text-mb-Create">

                                  {t("User Profile.Institute name")}
                                </label>
                                <input
                                  type="text"
                                  value={OrganizationName}
                                  onChange={(e) => setOrganizationName(e.target.value)}
                                  placeholder={t("User Profile.Enter Institute name")}
                                  className="mb-2 form-control Dark-Input-from-group"
                                />
                              </div>
                              <div>
                                <label className="mb-1 Text-mb-Create">{t("User Profile.City")} </label>
                                <Select
                                  defaultValue={cityId}
                                  onChange={(selectedOption) =>
                                    setCityId(selectedOption.value)
                                  }
                                  options={cityData}
                                  noOptionsMessage={() => t("modals.Search and Select City")}
                                  placeholder={t("modals.Search and Select City")}
                                  onInputChange={(inputValue) => {
                                    setCitySearch(inputValue);

                                  }}
                                  invalid={display && cityId === ""}
                                  styles={customStyles} {...wljSelectPortalProps}
                                />
                              </div>
                              <div className=" mt-2 mb-2 Text-mb-Create">
                                <label className="mb-1">{t("User Profile.Institute logo")}</label>
                                <input
                                  type="file"
                                  id="lastName"
                                  // className="form-control Dark-Input-from-group"
                                  placeholder=""
                                  onChange={handleFileChange}
                                />

                              </div>
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="closebtn me-2 ms-3"
                                  onClick={() => {
                                    setShowTooltip(false);
                                    setOrganizationName("");
                                    setIsEditMode(false);
                                    setEditingInstitute(null);
                                  }}
                                  style={{ width: "50px", height: "30px" }}
                                >
                                  {t("User Profile.Close")}
                                </button>

                                <button
                                  type="button"
                                  className="mainBtn"
                                  onClick={handleSaveInstitution}
                                  style={{ height: "30px !important", padding: '0px 11px' }}
                                >
                                  {t("Newsfeed.Save")}
                                </button>
                              </div>
                            </Form>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                      {InsName !== "" ? (
                        <div className="d-flex align-items-center wlj-org-selected-row">
                          <input
                            type="text"
                            value={InsName}
                            placeholder={t("modals.Enter Org name")}
                            className="mb-2 form-control"
                            disabled
                          />
                          <EditSharpIcon
                            className="material-symbols-sharp pointer me-2 mb-2"
                            onClick={() =>
                              handleEditInstitute({
                                id: getOrgInsTId,
                                name: InsName,
                                cityId: cityId,
                                logoImage: fileName,
                              })}
                          />
                          <CloseSharpIcon
                            className="material-symbols-sharp pointer me-2 mb-2"
                            onClick={handleCloseNewOrg}
                            title={t("User Profile.Close")}
                          />
                        </div>
                      ) : (
                        <div className="form-group">
                          <Select
                            defaultValue={valueIns}
                            options={optionsIns}
                            optionRenderer={renderOptionIns}
                            onOpen={handleOpenIns}
                            noOptionsMessage={() => t("modals.Search and Select Institution")}
                            onChange={handleChangeIns}
                            onMenuScrollToBottom={handleMenuScrollToBottomIns}
                            onInputChange={handleInputChangeIns}
                            isClearable
                            // onCreateOption={(newOption) => {
                            //   handleOpenCreateEducation();
                            //   handleCloseUSEREducation();
                            // }}
                            invalid={display && valueIns === ""}
                            placeholder={t("User Profile.Select Institution")}
                            className="iconsDropdown"
                            classNamePrefix="react-select"
                            styles={customStyles} {...wljSelectPortalProps}
                            formatOptionLabel={(option) => (
                              <div>
                                {option.label}
                                {option.isOrgVrfd === true ? (
                                  <img src={resume.verified} width={15} className="ms-1" />
                                ) : option.isOrgRgd === true ? (
                                  <img src={resume.register} width={15} className="ms-1" />
                                ) : (
                                  <img src={resume.unregister} width={15} className="ms-1" />
                                )}
                              </div>
                            )}
                          />
                        </div>
                      )}


                      {display && !InsName && !valueIns && !getOrgInsTId ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select Institution")}{" "}
                        </span>
                      ) : null}
                    </div>


                    <div className="col-md-6 mt-2">
                      <label htmlFor="about" className="wlj-edu-field-label">
                        {t("User Profile.City")}<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={cityId}
                        onChange={(selectedOption) =>
                          setCityId(selectedOption.value)
                        }
                        options={cityData}
                        noOptionsMessage={() => t("modals.Search and Select City")}
                        placeholder={t("User Profile.Select City")}
                        onInputChange={(inputValue) => {
                          setCitySearch(inputValue);

                        }}
                        invalid={display && cityId === ""}
                        className="iconsDropdown"
                        classNamePrefix="react-select"
                        styles={customStyles} {...wljSelectPortalProps}
                      />
                      {display && !cityId ? (
                        <span className="error_msg_lbl">{t("User Profile.Select City")} </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Field")}<span className="text-danger ms-2">*</span>
                      </label>

                      {showInputInsteadOfDropdown ? (
                        <input
                          type="text"
                          className="Dark-Input-from-group"
                          value={field}
                          onChange={(e) => setField(e.target.value)}
                          onBlur={() => {
                            if (field.trim()) {
                              setShowInputInsteadOfDropdown(false);
                            }
                          }}
                          autoFocus
                          isInvalid={display && field === ""}
                        />
                      ) : (
                        <CreatableSelect
                          options={optionsF}
                          styles={customStyles} {...wljSelectPortalProps}
                          className="iconsDropdown"
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Field")}
                          noOptionsMessage={() => t("modals.Search and Select Field")}
                          onOpen={handleOpenField}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              setField(selectedOption.value);
                              setShowInputInsteadOfDropdown(true); // switch to editable input
                            } else {
                              setField("");
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottomField}
                          onInputChange={handleInputChangeField}
                          isClearable
                          isValidNewOption={(inputValue, _, selectOptions) =>
                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                          }
                          onCreateOption={(inputValue) => {
                            const newOption = { label: inputValue, value: inputValue };
                            setOptionsF((prev) => [...prev, newOption]);
                            setField(inputValue);
                            setShowInputInsteadOfDropdown(true); // switch to input after create
                          }}
                          value={field ? { label: field, value: field } : null}
                          className={display && field === "" ? "is-invalid" : ""}
                        />
                      )}

                      {display && !field && (
                        <span className="error_msg_lbl"> {t("User Profile.Enter Field")}</span>
                      )}
                    </div>


                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Degree")}<span className="text-danger ms-2">*</span>
                      </label>
                      {showInputInsteadOfDropdownD ? (
                        <input
                          type="text"
                          className="Dark-Input-from-group"
                          value={degree}
                          onChange={(e) => setDegree(e.target.value)}
                          onBlur={() => {
                            if (degree.trim()) {
                              setShowInputInsteadOfDropdownD(false);
                            }
                          }}
                          autoFocus
                          isInvalid={display && degree === ""}
                        />
                      ) : (
                        <CreatableSelect
                          options={optionsD}
                          styles={customStyles} {...wljSelectPortalProps}
                          className="iconsDropdown"
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Degree")}
                          noOptionsMessage={() => t("modals.Search and Select Degree")}
                          onOpen={handleOpenDegree}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              setDegree(selectedOption.value);
                              setShowInputInsteadOfDropdownD(true); // switch to editable input
                            } else {
                              setDegree("");
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottomDegree}
                          onInputChange={handleInputChangeDegree}
                          isClearable
                          isValidNewOption={(inputValue, _, selectOptions) =>
                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                          }
                          onCreateOption={(inputValue) => {
                            const newOption = { label: inputValue, value: inputValue };
                            setOptionsD((prev) => [...prev, newOption]);
                            setDegree(inputValue);
                            setShowInputInsteadOfDropdownD(true); // switch to input after create
                          }}
                          value={degree ? { label: degree, value: degree } : null}
                          className={display && degree === "" ? "is-invalid" : ""}
                        />
                      )}
                      {/* <CreatableSelect
                                          defaultValue={degree}
                                          options={optionsD}
                                          styles={customStyles} {...wljSelectPortalProps}
                                          optionRenderer={renderOption}
                                          placeholder={"Search and Select Degree"}
                                          onOpen={handleOpenDegree}
                                          onChange={handleChangeDegree}
                                          onMenuScrollToBottom={handleMenuScrollToBottomDegree}
                                          onInputChange={handleInputChangeDegree}
                                          isClearable
                                           isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                          }
                                          onCreateOption={(inputValue) => {
                                            const newOption = { label: inputValue, value: inputValue };
                                            setOptionsD((prev) => [...prev, newOption]);
                                            setDegree(inputValue); // directly set the value
                                          }}
                                          value={degree ? { label: degree, value: degree } : null}
                          
                                          invalid={display && degree === ""}
                                        /> */}
                      {display && !degree ? (
                        <span className="error_msg_lbl"> {t("User Profile.Enter Degree")}</span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Grade")}
                      </label>
                      {/* <CreatableSelect
                                      defaultValue={grade}
                                      options={optionsG}
                                      styles={customStyles} {...wljSelectPortalProps}
                                      placeholder={"Search and Select Grade"}
                                      onMenuOpen={handleOpenGrade}
                                      onChange={handleChangeGrade}
                                      onMenuScrollToBottom={handleMenuScrollToBottomGrade}
                                      onInputChange={handleInputChangeGrade}
                                      isClearable
                                      isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                        !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                      }
                                      onCreateOption={(inputValue) => {
                                        const newOption = { label: inputValue, value: inputValue };
                                        setOptionsG((prev) => [...prev, newOption]);
                                        setGrade(inputValue); // directly set the value
                                      }}
                                      value={grade ? { label: grade, value: grade } : null}
                                      invalid={display && grade === ""}
                                    /> */}
                      {showInputInsteadOfDropdownG ? (
                        <input
                          type="text"
                          className="Dark-Input-from-group GradeFieldEducation"
                          value={grade}
                          onChange={(e) => setGrade(e.target.value)}
                          onBlur={() => {
                            if (grade.trim()) {
                              setShowInputInsteadOfDropdownG(false);
                            }
                          }}
                          autoFocus
                          isInvalid={display && grade === ""}
                        />
                      ) : (
                        <CreatableSelect
                          options={optionsG}
                          styles={customStyles} {...wljSelectPortalProps}
                          className="iconsDropdown"
                          classNamePrefix="react-select"
                          placeholder={t("User Profile.Select Grade")}
                          noOptionsMessage={() => t("modals.Search and Select Grade")}
                          onOpen={handleOpenGrade}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              setGrade(selectedOption.value);
                              setShowInputInsteadOfDropdownG(true); // switch to editable input
                            } else {
                              setGrade("");
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottomGrade}
                          onInputChange={handleInputChangeGrade}
                          isClearable
                          isValidNewOption={(inputValue, _, selectOptions) =>
                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                          }
                          onCreateOption={(inputValue) => {
                            const newOption = { label: inputValue, value: inputValue };
                            setOptionsG((prev) => [...prev, newOption]);
                            setGrade(inputValue);
                            setShowInputInsteadOfDropdownG(true); // switch to input after create
                          }}
                          value={grade ? { label: grade, value: grade } : null}
                          className={display && grade === "" ? "is-invalid" : ""}
                        />
                      )}


                      {display && !grade ? (
                        <span className="error_msg_lbl"> {t("User Profile.Enter Grade")}</span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Activities")}
                      </label>
                      <CreatableSelect
                        options={optionsA}
                        styles={customStyles} {...wljSelectPortalProps}
                        className="iconsDropdown"
                        classNamePrefix="react-select"
                        placeholder={t("User Profile.Select Activity")}
                        noOptionsMessage={() => t("modals.Search and Select Activity")}
                        onMenuOpen={handleOpenActivity}
                        onChange={handleChangeActivity}
                        onMenuScrollToBottom={handleMenuScrollToBottomActivity}
                        onInputChange={handleInputChangeActivity}
                        isClearable
                        isMulti
                        value={Array.isArray(activities) ? activities : []}
                        isValidNewOption={(inputValue, selectValue, selectOptions) =>
                          !!inputValue && !selectOptions.some(option => option.label === inputValue)
                        }
                        onCreateOption={(inputValue) => {
                          const newOption = { label: inputValue, value: inputValue };
                          setOptionsA((prev) => [...prev, newOption]);
                          setActivities((prev) => [...(prev || []), newOption]); // add to existing array
                        }}
                        invalid={display && (!activities || activities.length === 0)}
                      />

                    </div>

                    {/* {checkCurrent === false ?  */}
                    <div className="col-md-12 mt-2 d-flex align-items-center wlj-is-present-row">
                      <label htmlFor="edu-is-present" className="mb-0">{t("User Profile.Is Present")}</label>
                      <input
                        id="edu-is-present"
                        type="checkbox"
                        style={{ width: "20px", height: "20px", minHeight: "20px", padding: 0, marginLeft: "5px", outline: "none", boxShadow: "none" }}
                        //   id={`check-${item.id}`}
                        //   checked={selectedWorkLevelList.includes(item.id)}
                        onChange={() => setPresent(!present)}
                      />
                    </div>
                    {/* : ''} */}


                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Start Date")}<span className="text-danger ms-2">*</span>
                      </label>
                      <Flatpickr
                        className='form-control'
                        value={startDate}
                        onChange={date => setStartDateEdu(date[0] || null)} id='startDate' options={{
                          maxDate: "today", // Disables future dates
                          appendTo: modalContentRef.current || undefined,
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }} />
                      {display && !startDate ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select Start Date")}{" "}
                        </span>
                      ) : null}
                    </div>

                    {present === true ? '' : <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.End Date")}<span className="text-danger ms-2">*</span>
                      </label>
                      {/* <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      invalid={display && endDate === ""}
                    /> */}
                      <Flatpickr className='form-control' value={endDate} onChange={date => setEndDate(date[0] || null)} id='endDate' options={{
                        minDate: startDate || undefined,
                        appendTo: modalContentRef.current || undefined,
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }} />
                      {display && !endDate ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select End Date")}{" "}
                        </span>
                      ) : null}
                      {!present && isEducationDateRangeInvalid ? (
                        <span className="error_msg_lbl">
                          End date cannot be earlier than start date.
                        </span>
                      ) : null}
                    </div>}


                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Description")}
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        rows="2"
                        cols="50"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>

                  </div>
                  <div className="w-100 text-end mt-2 pt-3 pb-3 bg-white" style={{ borderTop: '1px solid #dee2e6', zIndex: 10 }}>
                    <div className="d-flex align-items-center justify-content-end px-3">
                      { }
                      {UserCcv === "Active" && <>
                        <input
                          type="checkbox"
                          style={{ width: "20px", height: "20px", minHeight: "20px", padding: 0, marginRight: "5px", outline: "none", boxShadow: "none" }}
                          onChange={() => setSync(!sync)}
                          checked={sync}
                        />
                        <label htmlFor="about" className="mb-0">
                          {t("User Profile.Sync With Resume")}
                        </label>
                      </>
                      }
                      <button
                        type="button"
                        className="closebtn me-2 ms-3"
                        onClick={handleCloseUSEREducation}
                        style={{ width: "70px" }}
                      >
                        {t("User Profile.Close")}
                      </button>

                      <button
                        type="button"
                        className="mainBtn1"
                        onClick={AddEducation}
                        style={{ width: "107px" }}
                      >
                        {t("User Profile.Submit")}
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Portal>
      )}
      {CreateCCVEducation && (
        <Portal layer="modal">
          <div
            className="modal fade show modal-lg wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="setting-header d-flex justify-content-between align-items-center">
                  <h6>Create Education</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={handleCloseCreateEducation}
                  />
                </div>
                <Form>
                  <div className="row p-4 settings CreateCompany">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Institution Name
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <Input
                        type="text"
                        value={institutionName}
                        onChange={(e) => setInstitutionName(e.target.value)}
                        invalid={display && institutionName === ""}
                      />
                      {display && !institutionName ? (
                        <span className="error_msg_lbl">
                          Enter Institution Name{" "}
                        </span>
                      ) : null}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        City<span className="text-danger ms-2">*</span>
                      </label>
                      <Select
                        defaultValue={cityId}
                        onChange={(selectedOption) =>
                          setCityId(selectedOption.value)
                        }
                        options={cityData}
                        noOptionsMessage={() => t("modals.Search and Select City")}
                        placeholder={t("modals.Search and Select City")}
                        onInputChange={(inputValue) => {
                          setCitySearch(inputValue);
                        }}
                        invalid={display && cityId === ""}
                        styles={customStyles} {...wljSelectPortalProps}
                      />
                      {display && !cityId ? (
                        <span className="error_msg_lbl">Please Select City </span>
                      ) : null}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Email
                      </label>
                      <Input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Phone No
                      </label>
                      <Input
                        type="text"
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Public URL
                      </label>
                      <Input
                        type="text"
                        value={publicUrl}
                        onChange={(e) => setPublicUrl(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Website
                      </label>
                      <Input
                        type="text"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        TagLine
                      </label>
                      <Input
                        type="text"
                        value={tagline}
                        onChange={(e) => setTagline(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        About
                      </label>
                      <Input
                        type="text"
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                      />
                    </div>



                    {/* <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      Specialization
                    </label>

                    <Select
                      defaultValue={specId}
                      onChange={(selectedOption) =>
                        setSpecId(selectedOption.value)
                      }
                      options={specData}
                      placeholder={" Select Specialization"}
                      invalid={display && specId === ""}
                      styles={customStyles} {...wljSelectPortalProps}
                    />
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      qualificationId
                    </label>
                    <Select
                      defaultValue={qualiId}
                      onChange={(selectedOption) =>
                        setQualiId(selectedOption.value)
                      }
                      options={qualiData}
                      placeholder={" Select Qualification"}
                      invalid={display && qualiId === ""}
                      styles={customStyles} {...wljSelectPortalProps}
                    />
                  </div> */}



                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Field<span className="text-danger ms-2">*</span>
                      </label>
                      <Input
                        type="text"
                        value={field}
                        onChange={(e) => setField(e.target.value)}
                        invalid={display && field === ""}
                      />
                      {display && !field ? (
                        <span className="error_msg_lbl">Enter Field </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Degree<span className="text-danger ms-2">*</span>
                      </label>
                      <Input
                        type="text"
                        value={degree}
                        onChange={(e) => setDegree(e.target.value)}
                        invalid={display && degree === ""}
                      />
                      {display && !degree ? (
                        <span className="error_msg_lbl">Enter Degree </span>
                      ) : null}
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Grade
                      </label>
                      <Input
                        type="text"
                        value={grade}
                        onChange={(e) => setGrade(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Activities
                      </label>
                      <Input
                        type="text"
                        value={activities}
                        onChange={(e) => setActivities(e.target.value)}
                      />
                    </div>
                    {checkCurrent === false ? <div className="col-md-12 mt-2 d-flex align-items-center">
                      <input
                        type="checkbox"
                        style={{ width: "40px" }}
                        //   id={`check-${item.id}`}
                        //   checked={selectedWorkLevelList.includes(item.id)}
                        onChange={() => setPresent(!present)}
                      />
                      <label htmlFor="about">IsPresent</label>
                    </div> : ''}

                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        Start Year<span className="text-danger ms-2">*</span>
                      </label>
                      {/* <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDateEdu(date)}
                      invalid={display && startDate === ""}
                    /> */}
                      <Flatpickr
                        className='form-control'
                        value={startDate} onChange={date => setStartDateEdu(date[0] || null)} id='dob' options={{
                          maxDate: "today", // Disables future dates
                          appendTo: modalContentRef.current || undefined,
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }} />
                      {display && !startDate ? (
                        <span className="error_msg_lbl">
                          Please Select Start Year{" "}
                        </span>
                      ) : null}
                    </div>

                    {present === true ? '' : <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        End Year
                      </label>
                      {/* <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      invalid={display && endDate === ""}
                    /> */}
                      <Flatpickr className='form-control' value={endDate} onChange={date => setEndDate(date[0] || null)} id='dob' options={{
                        minDate: startDate || undefined,
                        appendTo: modalContentRef.current || undefined,
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }} />
                      {display && !endDate ? (
                        <span className="error_msg_lbl">
                          Please Select End Year{" "}
                        </span>
                      ) : null}
                      {isEducationDateRangeInvalid ? (
                        <span className="error_msg_lbl">
                          End date cannot be earlier than start date.
                        </span>
                      ) : null}
                    </div>}

                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        Description
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        rows="4"
                        cols="50"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>

                    {/* <div className="col-md-12 mt-2 d-flex ">
                    <Input
                      type="checkbox"
                      style={{ width: "40px" }}
                      //   id={`check-${item.id}`}
                      //   checked={selectedWorkLevelList.includes(item.id)}
                      onChange={() => setPresent(true)}
                    />
                    <label htmlFor="about">IsPresent</label>
                  </div> */}

                    <div className="col-md-12 text-end mt-4">
                      <button
                        type="button"
                        className="mainBtn1"
                        style={{ width: "170px" }}
                        onClick={CreateEducation}
                      >
                        Create Education
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Portal>
      )}


      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default ProfileEducation;
